import { render, staticRenderFns } from "./VideosPlaylistModal.vue?vue&type=template&id=067dfd7f&scoped=true"
import script from "./VideosPlaylistModal.vue?vue&type=script&lang=js"
export * from "./VideosPlaylistModal.vue?vue&type=script&lang=js"
import style0 from "./VideosPlaylistModal.vue?vue&type=style&index=0&id=067dfd7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067dfd7f",
  null
  
)

export default component.exports